import { IOrderHistoryItemDetailInfo } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const orderHistoryDetailsAdapter: EntityAdapter<IOrderHistoryItemDetailInfo> = createEntityAdapter<IOrderHistoryItemDetailInfo>({
	selectId: item => item.webOrderId
});